import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { FileUpload } from 'primeng/fileupload';
import { lastValueFrom, map } from 'rxjs';
import {
  ProductControllerService,
  ProductVariant,
  ProductVariantCategoryDetailResponse,
  ProductVariantFidelizationSummary
} from 'src/app/admin-api';
import { TableColumn } from 'src/app/components/table';
import { AppDialogService } from 'src/app/services/dialog.service';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-batch-update',
  templateUrl: './batch-update.component.html',
  styleUrls: ['./batch-update.component.scss']
})
export class BatchUpdateComponent {
  variantsInStock: Array<ProductVariantFidelizationSummary> | undefined;
  variantsNoStock: Array<ProductVariantFidelizationSummary> | undefined;
  productsFailed: Array<ProductVariantFidelizationSummary> | undefined;
  cols: Array<TableColumn> = [
    new TableColumn(
      'Id',
      'productVariantId',
      true,
      'number',
      '/products/catalog/product-variant/',
      'productVariantId'
    ),
    new TableColumn(
      'External ID',
      'externalId',
      true,
      'number',
      '/products/catalog/product-variant/',
      'productVariantId'
    ),
    new TableColumn(
      'Nome',
      'productVariantName',
      true,
      'text',
      '/products/catalog/product-variant/',
      'productVariantId',
      true,
      'contains'
    ),
    new TableColumn(
      'InternalEAN',
      'internalEAN',
      true,
      'text',
      '/products/catalog/product-variant/',
      'productVariantId',
      true,
      'contains'
    ),
    new TableColumn(
      'Validade',
      'expiration',
      true,
      'text',
      undefined,
      undefined,
      true,
      'contains'
    ),
    new TableColumn('Peso (g)', 'weight', false, 'formattedNumber'),
    new TableColumn('Estoque', 'stock', false, 'formattedInteger'),
    new TableColumn('Pontos troca', 'tradePoints', false, 'formattedNumber'),
    new TableColumn(
      'Máximo trocas',
      'maxTradesPerPerson',
      false,
      'formattedInteger'
    )
  ];
  colsFailed: Array<TableColumn> = [
    new TableColumn('InternalEAN', 'internalEAN', false, 'text'),
    new TableColumn('Pontos troca', 'tradePoints', false, 'formattedNumber'),
    new TableColumn(
      'Máximo trocas',
      'maxTradesPerPerson',
      false,
      'formattedInteger'
    ),
    new TableColumn('Validade', 'expiration', false, 'text')
  ];
  colsCategory: Array<TableColumn> = [
    new TableColumn.Builder()
      .setHeader('EAN')
      .setField('internalEAN')
      .setRouterLink('/products/catalog/product-variant/')
      .setRouterLinkFieldName('productVariantId')
      .build(),
    new TableColumn.Builder()
      .setHeader('Produto')
      .setField('productVariantName')
      .setRouterLink('/products/catalog/product-variant/')
      .setRouterLinkFieldName('productVariantId')
      .setCondition('contains')
      .build(),
    new TableColumn.Builder()
      .setHeader('Categoria')
      .setField('categoryName')
      .setRouterLink('/products/category/')
      .setRouterLinkFieldName('categoryId')
      .setCondition('contains')
      .setDisplayFunction(
        (p: ProductVariantCategoryDetailResponse) =>
          `${p.categoryExternalId} ${p.categoryName}`
      )
      .build()
  ];
  colsProductNotFound: Array<TableColumn> = [
    new TableColumn.Builder()
      .setHeader('EAN')
      .setField('internalEAN')
      .setRouterLink('/products/catalog/product-variant/')
      .setRouterLinkFieldName('productVariantId')
      .build(),
    new TableColumn.Builder()
      .setHeader('Categoria')
      .setField('categoryName')
      .setRouterLink('/products/category/')
      .setRouterLinkFieldName('categoryId')
      .setCondition('contains')
      .setDisplayFunction(
        (p: ProductVariantCategoryDetailResponse) =>
          `${p.categoryExternalId} ${p.categoryName}`
      )
      .build()
  ];
  colsCategoryNotFound: Array<TableColumn> = [
    new TableColumn.Builder()
      .setHeader('Categoria')
      .setField('categoryName')
      .setRouterLink('/products/category/')
      .setRouterLinkFieldName('categoryId')
      .setCondition('contains')
      .setDisplayFunction(
        (p: ProductVariantCategoryDetailResponse) =>
          `${p.categoryExternalId} ${p.categoryName || ''}`
      )
      .build(),
    new TableColumn.Builder()
      .setHeader('EAN')
      .setField('internalEAN')
      .setRouterLink('/products/catalog/product-variant/')
      .setRouterLinkFieldName('productVariantId')
      .build(),
    new TableColumn.Builder()
      .setHeader('Produto')
      .setField('productVariantName')
      .setRouterLink('/products/catalog/product-variant/')
      .setRouterLinkFieldName('productVariantId')
      .build()
  ];
  minStock = 5;
  productsNotFound: Array<ProductVariantCategoryDetailResponse>;
  categoriesNotFound: Array<ProductVariantCategoryDetailResponse>;
  productCategoryItens: Array<ProductVariantCategoryDetailResponse>;
  colsSalePrice = [
    new TableColumn(
      'Id',
      'productVariantId',
      true,
      'number',
      '/products/catalog/product-variant/',
      'productVariantId'
    ),
    new TableColumn(
      'External ID',
      'externalId',
      true,
      'number',
      '/products/catalog/product-variant/',
      'productVariantId'
    ),
    new TableColumn(
      'Nome',
      'productVariantName',
      true,
      'text',
      '/products/catalog/product-variant/',
      'productVariantId',
      true,
      'contains'
    ),
    new TableColumn(
      'InternalEAN',
      'internalEAN',
      true,
      'text',
      '/products/catalog/product-variant/',
      'productVariantId',
      true,
      'contains'
    ),
    new TableColumn.Builder()
      .setHeader('Preço de venda')
      .setField('salePrice')
      .setType('currency')
      .build(),
    new TableColumn.Builder()
      .setHeader('Preço de custo')
      .setField('costPrice')
      .setType('currency')
      .build(),
    new TableColumn.Builder()
      .setHeader('Validade')
      .setField('expiration')
      .build()
  ];
  colsSalePriceNotFound = [
    new TableColumn.Builder()
      .setHeader('InternalEAN')
      .setField('internalEAN')
      .build()
  ];
  productSalePriceItens: Array<ProductVariant>;
  productSalePriceFail: Array<ProductVariant>;
  colsBasicInfo: Array<TableColumn> = [
    new TableColumn.Builder().setHeader('EAN').setField('internalEAN').build(),
    new TableColumn.Builder()
      .setHeader('Nome')
      .setField('productVariantName')
      .build(),
    new TableColumn.Builder().setHeader('Marca').setField('brandName').build()
  ];
  colsBasicInfoFail: Array<TableColumn> = [
    new TableColumn.Builder().setHeader('EAN').setField('internalEAN').build(),
    new TableColumn.Builder()
      .setHeader('Nome')
      .setField('productVariantName')
      .build(),
    new TableColumn.Builder().setHeader('Marca').setField('brandName').build()
  ];
  colsBasicInfoNotFound: Array<TableColumn> = [
    new TableColumn.Builder().setHeader('EAN').setField('internalEAN').build()
  ];
  productInfoItens: Array<ProductVariant>;
  productInfoFail: Array<ProductVariant>;
  productInfoNotFound: Array<ProductVariant>;

  constructor(
    private productsService: ProductControllerService,
    private title: Title
  ) {
    this.title.setTitle('Batch update de produtos de assinatura');
  }

  async uploadFile(
    $event: { files: File[] },
    fileUpload: FileUpload
  ): Promise<void> {
    try {
      LoaderService.showLoader();
      const products = await lastValueFrom(
        this.productsService
          .updateGlamclubXlsxFileForm($event.files[0])
          .pipe(map((data) => data.result))
      );
      this.variantsInStock = products?.filter(
        (p) => p.productVariantId && p.stock && p.stock > this.minStock
      );
      this.variantsNoStock = products?.filter(
        (p) => p.productVariantId && (!p.stock || p.stock <= this.minStock)
      );
      this.productsFailed = products?.filter((p) => !p.productVariantId);
      fileUpload.clear();
    } catch (error: any) {
      AppDialogService.showErrorDialog(error);
    } finally {
      LoaderService.showLoader(false);
    }
  }

  async uploadCategoryFile($event: { files: File[] }, fileUpload: FileUpload) {
    try {
      LoaderService.showLoader();
      const products = await lastValueFrom(
        this.productsService
          .updateBatchProductCategoryForm($event.files[0])
          .pipe(map((data) => data.result))
      );
      this.productCategoryItens = products.filter(
        (p) => p.productVariantId && p.categoryId
      );
      this.categoriesNotFound = products.filter((p) => !p.categoryId);
      this.productsNotFound = products.filter((p) => !p.productVariantId);
      fileUpload.clear();
    } catch (error) {
      AppDialogService.showErrorDialog(error);
    } finally {
      LoaderService.showLoader(false);
    }
  }

  async uploadSalePrices($event: { files: File[] }, fileUpload: FileUpload) {
    try {
      LoaderService.showLoader();
      const products = await lastValueFrom(
        this.productsService
          .updateBatchProductSalePriceForm($event.files[0])
          .pipe(map((data) => data.result))
      );
      this.productSalePriceItens = products.filter((p) => p.productVariantId);
      this.productSalePriceFail = products.filter((p) => !p.productVariantId);
      fileUpload.clear();
    } catch (error) {
      AppDialogService.showErrorDialog(error);
    } finally {
      LoaderService.showLoader(false);
    }
  }

  async uploadBasicInfo($event: { files: File[] }, fileUpload: FileUpload) {
    try {
      LoaderService.showLoader();
      const products = await lastValueFrom(
        this.productsService
          .updateBatchProductInfoForm($event.files[0])
          .pipe(map((data) => data.result))
      );
      this.productInfoItens = products.filter(
        (p) => p.productVariantId && p.brandId
      );
      this.productInfoNotFound = products.filter((p) => !p.productVariantId);
      this.productInfoFail = products.filter(
        (p) => p.productVariantId && !p.brandId
      );
      fileUpload.clear();
    } catch (error) {
      AppDialogService.showErrorDialog(error);
    } finally {
      LoaderService.showLoader(false);
    }
  }
}
